import { render } from "./Stats.vue?vue&type=template&id=10d6c3ec&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=10d6c3ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10d6c3ec"

export default script